<template>
  <div>
    <el-image-viewer
      v-if="imageVisible"
      :on-close="onClose"
      :z-index="9999"
      :url-list="mediaPreviewOption.previewSrcList"
    />
    <el-dialog
      title="预览"
      :visible="videoVisible || audioVisible"
      width="800px"
      append-to-body
      :before-close="beforeClose"
    >
      <div 
        class="preview-container"
        @mouseenter="arrowShow = true"
        @mouseleave="arrowShow = false"
      >
        <transition name="preview-arrow-left">
          <el-button
            v-show="arrowShow && mediaPreviewOption.previewSrcList.length > 1 && initialIndex > 0"
            class="preview-container__arrow preview-container__arrow--left"
            @click="handlePrev"
          >
            <i class="el-icon-arrow-left" />
          </el-button>
        </transition>
        <transition name="preview-arrow-right">
          <el-button
            v-show="arrowShow && mediaPreviewOption.previewSrcList.length > 1 && initialIndex < mediaPreviewOption.previewSrcList.length - 1"
            class="preview-container__arrow preview-container__arrow--right"
            @click="handleNext"
          >
            <i class="el-icon-arrow-right" />
          </el-button>
        </transition>
        <video
          v-if="mediaPreviewOption.previewType === 'video'"
          :ref="`media-${id}`"
          controls
          :poster="mediaPreviewOption.previewSrcList[initialIndex].poster"
          class="preview-video"
          :src="mediaPreviewOption.previewSrcList[initialIndex].src"
        >
          <source :src="mediaPreviewOption.previewSrcList[initialIndex].src" />
        </video>
        <audio
          v-if="mediaPreviewOption.previewType === 'audio'"
          :ref="`media-${id}`"
          controls
          :src="mediaPreviewOption.previewSrcList[initialIndex]"
        >
          <source :src="mediaPreviewOption.previewSrcList[initialIndex]" />
        </audio>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import throttle from 'lodash/throttle'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
  name: 'MediaPreview',
  components: {
    ElImageViewer
  },
  computed: {
    ...mapGetters([
      'previewVisible',
      'mediaPreviewOption'
    ])
  },
  watch: {
    previewVisible(val) {
      if (val) {
        this.id = new Date().getTime()
        this.initialIndex = this.mediaPreviewOption.initialIndex
      }
      this[`${this.mediaPreviewOption.previewType}Visible`] = val
    }
  },
  data() {
    return {
      id: 0,
      imageVisible: false,
      videoVisible: false,
      audioVisible: false,
      initialIndex: 0,
      arrowShow: false
    }
  },
  methods: {
    ...mapMutations({
      closeViewer: 'mediaPreview/CLOSE_MEDIA_VIEWER'
    }),
    handlePrev: throttle(function() {
      this.initialIndex > 0 && (this.initialIndex -= 1)
    }, 300),
    handleNext: throttle(function() {
      this.initialIndex < this.mediaPreviewOption.previewSrcList.length - 1 && (this.initialIndex += 1)
    }, 300),
    beforeClose(done) {
      this.$refs[`media-${this.id}`] && this.$refs[`media-${this.id}`].load()
      this.onClose()
      done()
    },
    onClose() {
      this.closeViewer()
    }
  },
}
</script>
<style lang="scss" scoped>
.preview-container {
  position: relative;
  &__arrow {
    position: absolute;
    top: 50%;
    z-index: 11;
    transform: translateY(-50%);
    text-align: center;
    font-size: 12px;
    border: none;
    outline: none;
    padding: 0;
    margin: 0;
    width: 36px;
    height: 36px;
    cursor: pointer;
    transition: .3s;
    border-radius: 50%;
    background-color: rgba(31, 45, 61, .11);
    color: #fff;
    &--left {
      left: 0;
    }
    &--right {
      right: 0;
    }
    &:hover {
      background-color: rgba(31,45,61,.23)
    }
  }
  video {
    width: 100%;
    height: 418px;
  }
  audio {
    width: calc(100% - 50px);
    margin: 0 25px;
  }
}

.preview-arrow-left-enter,
.preview-arrow-left-leave-active {
  transform: translateY(-50%) translateX(-10px);
  opacity: 0;
}

.preview-arrow-right-enter,
.preview-arrow-right-leave-active {
  transform: translateY(-50%) translateX(10px);
  opacity: 0;
}
</style>
